import { Canvas } from "@react-three/fiber";
import React from "react";

import { ProductStack } from "./ProductStack";

import { stage } from "./HomepageStage.module.css";

export function HomepageStage() {
  return (
    <div className={stage}>
      <Canvas
        camera={{
          position: [0, 5, 5],
        }}
      >
        <ProductStack />
      </Canvas>
    </div>
  );
}
